<template>
  <div class="app-container">
    <!-- 标题 -->
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form v-show="showSearch" ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
      <el-form-item label="表名称" prop="tableName">
        <el-input v-model="queryParams.tableName" placeholder="请输入表名称" clearable size="small" @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="列名称" prop="columnName">
        <el-input v-model="queryParams.columnName" placeholder="请输入列名称" clearable size="small" @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="表描述" prop="tableComment">
        <el-input v-model="queryParams.tableComment" placeholder="请输入表描述" clearable size="small" @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="模块名" prop="moduleName">
        <el-input v-model="queryParams.moduleName" placeholder="请输入模块名" clearable size="small" @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker v-model="dateRange" size="small" style="width: 215px" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['tool:gen:code']" type="primary" plain icon="el-icon-download" size="mini" @click="handleGenTable">生成</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['tool:gen:edit']" type="primary" plain icon="el-icon-plus" size="mini" @click="openCreateTable">创建</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['tool:gen:import']" type="info" plain icon="el-icon-upload" size="mini" @click="openImportTable">导入</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['tool:gen:edit']" type="success" plain icon="el-icon-edit" size="mini" :disabled="single" @click="handleEditTable">修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['tool:gen:remove']" type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple" @click="handleDelete">删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['tool:gen:edit']" type="warning" plain icon="el-icon-edit" size="mini" :disabled="multiple" @click="handleCommonEdit">编辑公共生成信息</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['tool:gen:edit']" type="danger" plain icon="el-icon-refresh" size="mini" :disabled="multiple" @click="handleSynchDb">同步</el-button>
      </el-col>
      <right-toolbar :show-search.sync="showSearch" @queryTable="getList" />
    </el-row>

    <el-table ref="tables" v-loading="loading" :data="tableList" :default-sort="defaultSort" @selection-change="handleSelectionChange" @sort-change="handleSortChange">
      <el-table-column type="selection" align="center" width="55" />
      <el-table-column label="序号" type="index" width="50" align="center">
        <template slot-scope="scope">
          <span>{{ (queryParams.current - 1) * queryParams.size + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="作者" align="center" prop="functionAuthor" :show-overflow-tooltip="true" width="80" />
      <el-table-column label="表名称" align="center" prop="tableName" :show-overflow-tooltip="true" width="160" sortable="custom" :sort-orders="['descending', 'ascending']" />
      <el-table-column label="表描述" align="center" prop="tableComment" :show-overflow-tooltip="true" width="170" />
      <el-table-column label="生成包路径" align="center" prop="packageName" :show-overflow-tooltip="true" width="140" />
      <el-table-column label="模块" align="center" prop="moduleName" :show-overflow-tooltip="true" width="80" sortable="custom" :sort-orders="['descending', 'ascending']" />
      <el-table-column label="模块描述" align="center" prop="moduleComment" :show-overflow-tooltip="true" width="80" />
      <el-table-column label="实体" align="center" prop="className" :show-overflow-tooltip="true" width="180" />
      <el-table-column label="创建时间" align="center" prop="createTime" width="170" sortable="custom" :sort-orders="['descending', 'ascending']" >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" align="center" prop="updateTime" width="170" sortable="custom" :sort-orders="['descending', 'ascending']" >
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.updateTime!=null"/>
          <span class="ml4">{{ scope.row.updateTime | dateTime }} </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" class-name="small-padding fixed-width" min-width="320">
        <template slot-scope="scope">
          <el-button v-hasPermi="['tool:gen:preview']"
            type="text"
            size="small"
            icon="el-icon-view"
            @click="handlePreview(scope.row)"
          >预览</el-button>
          <el-button v-hasPermi="['tool:gen:edit']"
            type="text"
            size="small"
            icon="el-icon-edit"
            @click="handleEditTable(scope.row)"
          >编辑</el-button>
          <el-button v-hasPermi="['tool:gen:remove']"
            type="text"
            size="small"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >删除</el-button>
          <el-button v-hasPermi="['tool:gen:edit']"
            type="text"
            size="small"
            icon="el-icon-refresh"
            @click="handleSynchDb(scope.row)"
          >同步</el-button>
          <el-button v-hasPermi="['tool:gen:code']"
            type="text"
            size="small"
            icon="el-icon-download"
            @click="handleGenTable(scope.row)"
          >生成代码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
    <!-- 预览界面 -->
    <el-dialog :title="preview.title" :visible.sync="preview.open" width="80%" top="5vh" :close-on-click-modal="false" append-to-body class="scrollbar">
      <el-tabs v-model="preview.activeName">
        <el-tab-pane
          v-for="(value, key) in preview.data"
          :key="key"
          :label="key.substring(key.lastIndexOf('/')+1,key.indexOf('.vm'))"
          :name="key.substring(key.lastIndexOf('/')+1,key.indexOf('.vm'))"
        >
          <el-link v-clipboard:copy="value" v-clipboard:success="clipboardSuccess" :underline="false" icon="el-icon-document-copy" style="float:right">复制</el-link>
          <pre><code class="hljs" v-html="highlightedCode(value, key)" /></pre>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 公共生成信息修改界面 -->
    <el-dialog :title="commonEdit.title" :visible.sync="commonEdit.open" width="500" top="30%" :close-on-click-modal="false" append-to-body class="scrollbar">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-row>
          <el-form-item label="作者" prop="functionAuthor">
            <el-input v-model="form.functionAuthor" placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="packageName">
            <span slot="label">
              生成包路径
              <el-tooltip content="生成在哪个java包下，例如 com.ruoyi.system" placement="top">
                <i class="el-icon-question" />
              </el-tooltip>
            </span>
            <el-input v-model="form.packageName" />
          </el-form-item>
          <el-form-item prop="moduleName">
            <span slot="label">
              生成模块名
              <el-tooltip content="可理解为子系统名，例如 system" placement="top">
                <i class="el-icon-question" />
              </el-tooltip>
            </span>
            <el-input v-model="form.moduleName" />
          </el-form-item>
          <el-form-item prop="moduleComment">
            <span slot="label">
              生成模块描述
              <el-tooltip content="可理解为子系统描述，例如 系统模块" placement="top">
                <i class="el-icon-question" />
              </el-tooltip>
            </span>
            <el-input v-model="form.moduleComment" />
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <import-table ref="import" @ok="handleQuery" />
    <create-table ref="create" @ok="handleQuery" />
  </div>
</template>

<script>
import { listTable, previewTable, delTable, genCode, synchDb, updateCommon } from '@/api/tool/gen'
import importTable from './importTable'
import createTable from './createTable'
import hljs from 'highlight.js/lib/highlight'
import 'highlight.js/styles/github-gist.css'

hljs.registerLanguage('java', require('highlight.js/lib/languages/java'))
hljs.registerLanguage('xml', require('highlight.js/lib/languages/xml'))
hljs.registerLanguage('html', require('highlight.js/lib/languages/xml'))
hljs.registerLanguage('vue', require('highlight.js/lib/languages/xml'))
hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'))
hljs.registerLanguage("typescript", require("highlight.js/lib/languages/typescript"))
hljs.registerLanguage('sql', require('highlight.js/lib/languages/sql'))

export default {
  name: 'Gen',
  components: { importTable, createTable },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 唯一标识符
      uniqueId: '',
      // 选中数组
      ids: [],
      // 选中表数组
      tableNames: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 表数据
      tableList: [],
      // 日期范围
      dateRange: '',
      // 默认排序
      defaultSort: { prop: 'tableName', order: 'ascending' },
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        tableName: undefined,
        tableComment: undefined,
        moduleName: undefined,
        columnName: undefined
      },
      // 预览参数
      preview: {
        open: false,
        title: '代码预览',
        data: {},
        activeName: 'domain.java'
      },
      commonEdit: {
        open: false,
        title: '修改公共生成信息',
        data: {}
      },
      form: {},
      rules: {
        functionAuthor: [
          { required: true, message: '请输入作者', trigger: 'blur' }
        ],
        packageName: [
          { required: true, message: '请输入生成包路径', trigger: 'blur' }
        ],
        moduleName: [
          { required: true, message: '请输入生成模块名', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.queryParams.orderByColumn = this.defaultSort.prop
    this.queryParams.isAsc = this.defaultSort.order
    this.getList()
  },
  activated() {
    const time = this.$route.query.t
    if (time != null && time != this.uniqueId) {
      this.uniqueId = time
      this.queryParams.current = Number(this.$route.query.current)
      this.getList()
    }
  },
  methods: {
    /** 查询表集合 */
    getList() {
      this.loading = true
      listTable(this.addDateRange(this.queryParams, this.dateRange)).then(response => {
        this.tableList = response.rows
        this.total = response.total
        this.loading = false
      }
      )
    },
    // 取消按钮
    cancel() {
      this.commonEdit.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        tableIds: null,
        functionAuthor: null,
        packageName: null,
        moduleName: null
      }
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1
      this.getList()
    },
    /** 生成代码操作 */
    handleGenTable(row) {
      const tableNames = row.tableName || this.tableNames
      if (tableNames == '') {
        this.$modal.msgError('请选择要生成的数据')
        return
      }
      if (row.genType === '1') {
        genCode(row.tableName).then(response => {
          this.$modal.msgSuccess('成功生成到自定义路径：' + row.genPath)
        })
      } else {
        const zipName = Array.isArray(tableNames) ? "blog.zip" : tableNames + ".zip"
        this.$download.zip("/admin/gen/batchGenCode?tables=" + tableNames, zipName)
      }
    },
    /** 同步数据库操作 */
    handleSynchDb(row) {
      let tableIds = this.ids
      if (row.tableId) {
        tableIds = [row.tableId]
      }
      const tableNames = row.tableName || this.tableNames
      this.$modal.confirm('是否确认同步表名称为"' + tableNames + '"的数据项？').then(function() {
        return synchDb({ ids: tableIds })
      }).then(() => {
        this.getList()
        this.$modal.msgSuccess('同步成功')
      }).catch(() => {})
    },
    /** 打开导入表弹窗 */
    openImportTable() {
      this.$refs.import.show()
    },
    /** 打开创建表弹窗 */
    openCreateTable() {
      this.$refs.create.show()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.resetForm('queryForm')
      this.queryParams.current = 1
      this.$refs.tables.sort(this.defaultSort.prop, this.defaultSort.order)
    },
    /** 预览按钮 */
    handlePreview(row) {
      previewTable(row.tableId).then(response => {
        this.preview.data = response.data
        this.preview.open = true
        this.preview.activeName = 'domain.java'
      })
    },
    /** 高亮显示 */
    highlightedCode(code, key) {
      const vmName = key.substring(key.lastIndexOf('/') + 1, key.indexOf('.vm'))
      var language = vmName.substring(vmName.indexOf('.') + 1, vmName.length)
      const result = hljs.highlight(language, code || '', true)
      return result.value || '&nbsp;'
    },
    /** 复制代码成功 */
    clipboardSuccess() {
      this.$modal.msgSuccess('复制成功')
    },
    /** 多选框选中数据 */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.tableId)
      this.tableNames = selection.map(item => item.tableName)
      this.single = selection.length != 1
      this.multiple = !selection.length
    },
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop
      this.queryParams.isAsc = column.order
      this.getList()
    },
    /** 修改按钮操作 */
    handleEditTable(row) {
      const tableId = row.tableId || this.ids[0]
      const tableName = row.tableName || this.tableNames[0]
      const params = { current: this.queryParams.current,tableId:tableId,tableName: tableName }
      this.$router.push({path:'/tool/gen-edit',query: params})
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const tableIds = row.tableId || this.ids
      const tableNames = row.tableName || this.tableNames
      this.$modal.confirm('是否确认删除表名称为"' + tableNames + '"的数据项？').then(function() {
        return delTable(tableIds)
      }).then(() => {
        this.getList()
        this.$modal.msgSuccess('删除成功')
      }).catch(() => {})
    },
    /** 编辑生成信息*/
    handleCommonEdit() {
      this.reset()
      this.commonEdit.open = true
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.form.tableIds = this.ids
          if (this.form.tableIds != null) {
            updateCommon(this.form).then(response => {
              this.$modal.msgSuccess('修改成功')
              this.commonEdit.open = false
              this.getList()
            })
          }
        }
      })
    }
  }
}
</script>
